import React from 'react'
import { useSearchParams } from 'react-router-dom'
import HeroImageForms from '../../../components/Commons/Forms/Layout/HeroImageForms';
import FooterSuscription from '../../../components/Commons/Forms/Layout/FooterSuscription';
import HeaderFormCampaign from '../../../components/Commons/Forms/HeaderFormCampaign';
import ModalInfoValidate from './ModalInfoValidate';
import { Helmet } from "react-helmet";
import FormRegisterCampaign from './FormRegisterCampaign';


const RegisterCampaign = () => {
    const [searchParams] = useSearchParams()
    const token = searchParams.get('token')
    const [userData, setUserData] = React.useState({})
    const campaignDataFromStorage = sessionStorage.getItem('campaignData')
    const campaignData = campaignDataFromStorage ? JSON.parse(campaignDataFromStorage) : null
    
    function registerUser(_userData, submit = false) {
        const data = {...userData, ..._userData, submit};
        setUserData(data);
        if(submit){
            window.$('#validate-info').modal('show');
        }
    }
    return <>
    <Helmet>
      <title>Suscríbete</title>
    </Helmet>
    <div className="home">
        <HeroImageForms>
            <HeaderFormCampaign campaignData={campaignData} token={token}>
                <FormRegisterCampaign registerUser={registerUser} />
            </HeaderFormCampaign>
            <FooterSuscription />
        </HeroImageForms>
        <ModalInfoValidate userData={userData} token={token} />
    </div>
    </>
}

export default RegisterCampaign
